import React, { useEffect, useState } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import styled from 'styled-components';
import { yupResolver } from '@hookform/resolvers/yup';
import useReviewEdit from '../../common/hook/useReviewEdit';
import Tabs from '../../../../../components/Tabs';
import CsReviewEditForm from '../CsReviewEditForm';
import CsDetailProductInfo from '../../../common/CsDetailProductInfo';
import ReviewPointRetrieveModal from '../../common/modal/NewReviewPointRetrieveModal';
import FullscreenLoader from '../../../../../components/base/FullscreenLoader';
import CsReviewDetailNavbar from '../CsReviewDetailNavbar';
import PointRetrieveDetailWrap from '../CsReviewDetailInfo';
import CsReviewTagInfo from '../../../common/review/CsReviewTagInfo';
import { FORM_DEFAULT_VALUE } from '../../common/constants';
import { reviewUpdateFormValidationSchema } from '../../common/util/reviewFormValidate';
import './CsReviewDetailWrap.scss';

const Form = styled.form`
  width: 100%;
`;

const CsReviewDetailWrap = () => {
  const {
    reviewDetailInfo,
    productInfo,
    userDetailInfo,
    pointLogsInfo,
    criteriaInfo,
    isLoading,
    isSuccess,
    handleClickRetrievePoint,
    canPointRetrieved,
    productId,
    updateReview,
  } = useReviewEdit();

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(reviewUpdateFormValidationSchema),
    defaultValues: FORM_DEFAULT_VALUE,
    resetOptions: {
      keepDirtyValues: true,
    },
  });

  const [currentTabKey, setCurrentTabKey] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalOpen = () => {
    setIsModalOpen(!isModalOpen);
  };

  const onSubmit = (data) => {
    if (!data) return;
    updateReview({
      id: reviewDetailInfo.id,
      data: {
        rate: data?.rate,
        content: data?.content,
        imgUrls: data?.imgUrls,
        tagIds: data?.tagIds.map((tag) => tag.id),
        reviewCriteria: data?.reviewCriteria,
        status: data?.status,
      },
    });
  };

  const onError = (error) => {
    console.log('error', error);
    setCurrentTabKey(0);
  };

  const checkKeyDown = (e) => {
    if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (isSuccess && reviewDetailInfo) {
      methods.reset({
        buyerId: reviewDetailInfo?.user.id,
        buyerName: reviewDetailInfo?.user.name,
        createDate: reviewDetailInfo?.createDate,
        orderItemId: reviewDetailInfo?.orderItemId,
        status: reviewDetailInfo?.status,
        isReported: reviewDetailInfo.isReported,
        rate: reviewDetailInfo?.rate,
        imgUrls: reviewDetailInfo?.reviewAttachments?.map((image) => image.url),
        content: reviewDetailInfo?.content,
        tagIds: reviewDetailInfo?.reviewTags,
        reviewCriteria: reviewDetailInfo?.reviewCriteria,
      });
    }
  }, [isSuccess, reviewDetailInfo, methods.reset, methods]);

  if (isLoading) {
    return <FullscreenLoader visible={true} />;
  }

  return (
    <div className="cs-review-detail-wrap">
      <FormProvider {...methods}>
        {/* 하단 네브바 */}
        <Form id="update-review-form" onSubmit={methods.handleSubmit(onSubmit, onError)} onKeyDown={checkKeyDown}>
          <CsReviewDetailNavbar onClick={handleModalOpen} canPointRetrieved={canPointRetrieved} />
          <Tabs
            className="review-detail-tabs"
            activeKey={currentTabKey}
            onChange={(tabKey) => setCurrentTabKey(tabKey)}
            list={[
              {
                title: '상품 후기 정보',
                content: (
                  <>
                    {/*상품 정보*/}
                    {productInfo && <CsDetailProductInfo productInfo={productInfo} />}
                    {/*후기 정보*/}
                    {criteriaInfo && reviewDetailInfo && (
                      <CsReviewEditForm reviewInfo={reviewDetailInfo} criteriaInfo={criteriaInfo} />
                    )}
                  </>
                ),
              },
              {
                title: '태그 정보',
                content: (
                  <Controller
                    name="tagIds"
                    control={methods.control}
                    render={({ field: { onChange, value } }) => (
                      <CsReviewTagInfo name="tagIds" productId={productId} onChange={onChange} value={value} />
                    )}
                  />
                ),
              },
              {
                title: '포인트 정보',
                content: <PointRetrieveDetailWrap reviewDetailInfo={reviewDetailInfo} />,
                disabled: !reviewDetailInfo?.pointReturned,
              },
            ]}
          />
          {isModalOpen && (
            <ReviewPointRetrieveModal
              isOpen={isModalOpen}
              onClick={handleClickRetrievePoint}
              closeModal={handleModalOpen}
              pointLogsInfo={pointLogsInfo}
              reviewDetailInfo={reviewDetailInfo}
              userDetailInfo={userDetailInfo}
            />
          )}
        </Form>
      </FormProvider>
    </div>
  );
};

export default CsReviewDetailWrap;
